export default __webpack_public_path__ + "static/media/Petideal Creamy Tuna.a97536b1.png";